
import * as CSS from 'csstype';
import styled from 'styled-components';

export interface IPanelContentProps {
    padding?: CSS.PaddingProperty<string>;
}

export const PanelContent = styled.div<IPanelContentProps>`
    padding: ${props => props.padding || '30px'};
`;
